import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"clipboard-icon\"><rect id=\"clipboard\" x=\"4.5\" y=\"4.5\" width=\"11\" height=\"13\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"1.5\" fill=\"none\"></rect><path id=\"clipboard-top\" d=\"M6.5 4.5C6.5 3.94772 6.94772 3.5 7.5 3.5H12.5C13.0523 3.5 13.5 3.94772 13.5 4.5V5.5H6.5V4.5Z\" stroke=\"currentColor\" stroke-width=\"1.5\" fill=\"none\"></path><line id=\"clipboard-line-1\" x1=\"7.5\" y1=\"8.5\" x2=\"12.5\" y2=\"8.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></line><line id=\"clipboard-line-2\" x1=\"7.5\" y1=\"11.5\" x2=\"12.5\" y2=\"11.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></line><line id=\"clipboard-line-3\" x1=\"7.5\" y1=\"14.5\" x2=\"10.5\" y2=\"14.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></line></g>", 1)
  ]))]))
}
export default { render: render }